import React, { useState } from 'react';

import AnimateHeight from 'react-animate-height';

import Button from '@atlaskit/button';

import { AdditionalFeedbackModal } from 'src/components/code-reviewer-feedback/src/components/additional-feedback-modal';
import { CodeReviewerTextSubmissionState } from 'src/components/code-reviewer-feedback/src/types';
import { CodeReviewerFeedbackSentiment } from 'src/components/conversation/src/internal/analytics';
import { useIntl } from 'src/hooks/intl';

import messages from '../i18n/request-additional-feedback.i18n';

interface Props {
  prUrl?: string;
  sentiment: CodeReviewerFeedbackSentiment;
  textSubmissionState: CodeReviewerTextSubmissionState;
  handleTextFeedbackSent: () => void;
  hasCodeSuggestions?: boolean;
}
export const RequestAdditionalFeedback = ({
  prUrl,
  sentiment,
  textSubmissionState,
  handleTextFeedbackSent,
  hasCodeSuggestions,
}: Props): JSX.Element => {
  const [openModal, setOpenModal] = useState<boolean>(false);
  const isOpen = textSubmissionState === 'pending';
  const intl = useIntl();

  return (
    <>
      <AnimateHeight duration={250} animateOpacity height={isOpen ? 'auto' : 0}>
        <p style={{ paddingTop: '10px' }}>
          {intl.formatMessage(messages.requestAdditionalFeedback)}{' '}
          <Button
            appearance="link"
            spacing="none"
            onClick={() => setOpenModal(true)}
          >
            {intl.formatMessage(messages.additionalFeedbackButtonText)}
          </Button>
        </p>
      </AnimateHeight>
      {openModal && prUrl && (
        <AdditionalFeedbackModal
          onClose={() => setOpenModal(false)}
          handleFeedbackSent={handleTextFeedbackSent}
          prUrl={prUrl}
          sentiment={sentiment}
          hasCodeSuggestions={hasCodeSuggestions ?? false}
        />
      )}
    </>
  );
};
